import { isBrowser } from '../isBrowser';
import { AnalyticsController } from '../../layout/Analytics';

interface UtagEventProps {
    event: string;
    component: string;
    asset?: string;
    action?: string;
    buttonText?: string;
    ariaLabel?: string;
    [key: string]: any;
}

const findAnalyticsElement = (target: HTMLElement): HTMLElement | null => {
    let current: HTMLElement | null = target;
    while (current && current !== document.body) {
        if (current.hasAttribute(`data-analytics-ignore`)) return null;
        if (
            current.hasAttribute(`data-analytics`) &&
            current.hasAttribute(`data-analytics-component`)
        ) {
            return current;
        }
        current = current.parentElement;
    }
    return null;
};

let isInitialized = false;

const handleAnalyticsClick = (event: MouseEvent) => {
    const element = findAnalyticsElement(event.target as HTMLElement);
    if (!element) return;

    const analyticsData = element.getAttribute(`data-analytics`);
    if (!analyticsData) return;

    // Use textContent instead of innerText for better performance
    const buttonText = element.textContent?.trim() || undefined;

    let payload: UtagEventProps = {
        event: `autoparse`,
        component: element.getAttribute(`data-analytics-component`) || ``,
        action: element.getAttribute(`data-analytics-action`) || undefined,
        buttonText,
        ariaLabel: element.getAttribute(`aria-label`) || undefined,
    };

    try {
        const parsed = JSON.parse(analyticsData);
        payload = { ...payload, ...parsed };
    } catch {
        payload.asset = analyticsData;
    }

    // Convert all values to strings for AnalyticsController
    const stringPayload: { [key: string]: string } = {};
    for (const key in payload) {
        if (payload[key] !== undefined && payload[key] !== null) {
            stringPayload[key] = String(payload[key]);
        }
    }

    AnalyticsController.track(stringPayload);
};

export const initAutoAnalytics = () => {
    if (!isBrowser || isInitialized) return;

    document.addEventListener(`click`, handleAnalyticsClick, true);
    isInitialized = true;
};

export const cleanupAutoAnalytics = () => {
    if (!isBrowser || !isInitialized) return;

    document.removeEventListener(`click`, handleAnalyticsClick, true);
    isInitialized = false;
};
